import { FC } from 'react'
import { useTheme } from '@emotion/react'

// icons
import { icons } from '@/assets'
// hooks
import { useAppDispatch } from '@/hooks'
// features
import { reportCloseReportPostModal } from '@/features'
// components
import { CardHeaderMobile, ModalCardTitle, ModalCardSubtitle, Error } from '@/components'

// components
import { ReportPostForm } from './components'
// styles
import { styles } from './styles'

type ReportPostCardProps = {}

export const ReportPostCard: FC<ReportPostCardProps> = () => {
  const theme = useTheme()

  const dispatch = useAppDispatch()
  const reportPostError = ''

  return (
    <div
      css={styles(theme).card.main}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      {/* mobile header */}
      <div css={styles(theme).card.header}>
        <CardHeaderMobile onCloseClick={() => dispatch(reportCloseReportPostModal())} />
      </div>

      {/* title */}
      <div css={styles(theme).card.title}>
        <ModalCardTitle text="Report" icon={icons.AlertTriangle} />
      </div>

      {/* subtitle */}
      <div css={styles(theme).card.subtitle}>
        <ModalCardSubtitle text="Kindly provide details of your concern regarding this post." />
      </div>

      <div css={styles(theme).card.content.main}>
        {/* form */}
        <div css={styles(theme).card.content.form}>
          <ReportPostForm />
        </div>

        <div css={styles(theme).card.content.error}>
          <Error error={reportPostError} />
        </div>
      </div>
    </div>
  )
}

ReportPostCard.propTypes = {}
